<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  mounted() {
    console.log("App Launch");
  },
};
</script>

<style lang="less">
body {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: @black;
  font-size: @font-size-md;
  background: #e8edf4;
}

* {
  margin: 0;
  padding: 0;
}
</style>
